export default class HelperPhone {
  static extractDDD = (phone: string): string => phone.slice(0, 5);

  static extractNumber = (phone: string): string => phone.slice(5);

  static build = (phone: string): { ddd: string; number: string } => {
    const ddd = HelperPhone.extractDDD(phone);
    const number = HelperPhone.extractNumber(phone);

    return {
      ddd,
      number,
    };
  };
}
